import { useEffect } from "react";

import AdminHome from "../components/APanel/AdminHome";
import PreloadAppData from "../components/Utils/PreloadAppData";

function APanel() {
   useEffect(() => {
      document.title = "Instruire Auto | APanel";
   }, []);

   return (
      <main className="main">
         <AdminHome />

         <PreloadAppData />
      </main>
   );
}

export default APanel;
